/**
 * Brand & content constants for Townhouse Al-Shamkha landing page.
 * All text is in Arabic; intended for RTL rendering.
 */

export const BRAND = {
  companyAr: "مُيسر للتطوير العقاري",
  companyEn: "MUYASSR REAL ESTATE",
  projectAr: "تاون هاوس الشامخة",
  cityAr: "الدمام",
  phone: "+966500550223",
  phoneDisplay: "+966 50 055 0223",
  email: "contact@muyassar-ra.com",
  tiktok: "muyassr.re",
  tiktokUrl: "https://www.tiktok.com/@muyassr.re",
  whatsappUrl: "https://wa.me/966500550223",
  telUrl: "tel:+966500550223",
  // Scarcity scaffolding — adjust live numbers when sales update
  unitsTotal: 24,
  unitsRemaining: 7,
};

export const HERO = {
  eyebrow: "تاون هاوس الشامخة — الدمام",
  title: "تـاون هـاوس الشامخـة",
  subtitle: "اسم تثق به في عالم العقار",
  description:
    "مشروع سكني حديث من مُيسر للتطوير العقاري يقدم وحدات دوبلكس بتصاميم متعددة، جودة تنفيذ عالية، وضمانات موثوقة في موقع يعزز الراحة والقيمة.",
  cta: "سجّل اهتمامك",
  ctaSecondary: "تعرّف على المشروع",
};

export const ABOUT = {
  kicker: "عن المشروع",
  headline: "حياة عائلية متكاملة",
  body: [
    "تاون هاوس الشامخة مشروع سكني في الدمام يجمع بين التخطيط العملي، التفاصيل المعمارية الهادئة، ومساحات تناسب احتياجات العائلة اليومية.",
    "يضم المشروع نماذج دوبلكس متنوعة بمساحات تبدأ من 227م² وتصل إلى 427م² تقريبًا، مع توزيع داخلي مدروس يمنح كل وحدة خصوصية ومرونة في الاستخدام.",
    "تقدمه مُيسر للتطوير العقاري بمعايير تنفيذ واضحة وضمانات ممتدة وخدمات ما بعد البيع، ليكون قرار السكن أو الاستثمار أكثر اطمئنانًا.",
  ],
  stats: [
    { label: "نماذج دوبلكس متنوعة", value: "6", note: "تصاميم متعددة للعائلة" },
    { label: "تبدأ منها المساحات", value: "227م²", note: "وتصل حتى 427م²" },
    { label: "ضمان إنشائي معتمد", value: "10 سنوات", note: "حماية موثوقة" },
  ],
};

export const LOCATION = {
  kicker: "موقع المشروع",
  headline: "قرب يعزز القيمة",
  description:
    "موقع استراتيجي في الدمام يوفر سهولة الوصول ويعزز القيمة المستقبلية للعقار.",
  points: [
    { time: "16", label: "مركز الملك عبدالعزيز الثقافي", icon: "landmark" },
    { time: "24", label: "مطار الملك فهد الدولي", icon: "plane" },
    { time: "14", label: "مستشفى السعودي الألماني", icon: "hospital" },
  ],
  unit: "دقيقة",
};

export const SPECS = {
  kicker: "المواصفات الفنية",
  headline: "وفي الجودة سلامة",
  description:
    "معايير بناء ترتقي بالتفاصيل وتُترجم الجودة إلى واقع ملموس، بحلول هندسية مدروسة ومواد عالية الكفاءة.",
  items: [
    { title: "عزل مائي وحراري", desc: "حماية كاملة للمنشأة وضمان كفاءة التشغيل." },
    { title: "نوافذ ألمنيوم دبل جلاس", desc: "عزل صوتي وحراري بأعلى المعايير." },
    { title: "أبواب خارجية قوية وآمنة", desc: "تشكيلة معدنية بتشطيب فاخر ومتانة عالية." },
    { title: "أنظمة سباكة بضمانات مصنعية", desc: "مواد معتمدة وضمان طويل الأمد." },
    { title: "تمديدات كهربائية", desc: "وفق أعلى معايير السلامة وكفاءة الأداء." },
    { title: "أسقف جبسية", desc: "تشطيب ناعم وتصميم عصري." },
    { title: "أرضيات وبلاط فاخر", desc: "بمعايير جودة عالية وتشكيلات راقية." },
    { title: "تشطيبات داخلية بإتقان هندسي", desc: "عناية بالتفاصيل في كل ركن." },
  ],
};

export const WARRANTIES = {
  kicker: "الضمانات وخدمات ما بعد البيع",
  headline: "وفي الضمان ثقة واستدامة",
  description:
    "نلتزم بتقديم ضمانات موثقة تغطي العناصر الأساسية، مدعومة بخدمات ما بعد البيع لضمان استمرارية الأداء.",
  groups: [
    {
      title: "الهيكل الإنشائي",
      items: [
        { name: "تأمين التعاونية ضد العيوب الخفية", period: "10 سنوات" },
        { name: "تقرير إشراف هندسي معتمد", period: "موثق" },
      ],
    },
    {
      title: "الكهرباء",
      items: [
        { name: "مفاتيح وأفياش", period: "25 سنة" },
        { name: "أسلاك وكابلات", period: "10 سنوات" },
        { name: "طبلون كهربائي", period: "25 سنة" },
        { name: "سخانات", period: "5 سنوات" },
        { name: "إنتركوم وإنارة", period: "سنتان" },
      ],
    },
    {
      title: "السباكة",
      items: [
        { name: "تمديدات الصرف الصحي", period: "15 سنة" },
        { name: "خلاطات استحمام", period: "15 سنة" },
        { name: "سيفونات إفرنجي", period: "15 سنة" },
        { name: "خزانات مياه أرضية", period: "25 سنة" },
        { name: "خزانات مياه علوية", period: "10 سنوات" },
      ],
    },
    {
      title: "ضمانات أخرى",
      items: [
        { name: "عزل الأسقف والمطابخ", period: "10 سنوات" },
        { name: "عزل دورات المياه", period: "10 سنوات" },
        { name: "أبواب خشب", period: "10 سنوات" },
        { name: "أعمال حدادة", period: "3 سنوات" },
        { name: "ألمنيوم", period: "سنتان" },
      ],
    },
  ],
  afterSales: [
    "متابعة بعد الاستلام لضمان رضاكم الكامل",
    "تنظيم وتسليم ملف متكامل للضمانات والمستندات",
    "دعم في معالجة أي ملاحظات أو احتياجات تشغيلية",
    "استشارة مستمرة في أي قرار عقاري مستقبلي",
    "خدمة التصميم الداخلي بأسعار تفضيلية",
    "توريد وتركيب المطابخ بعروض خاصة",
    "تنفيذ وتجهيز أنظمة المنزل الذكي بباقات مميزة",
    "خدمة صيانة دورية بأسعار العضوية لأصحاب الوحدات",
    "إدارة عقارية احترافية للتأجير أو الاستثمار عند الطلب",
  ],
};

export const UNIT_MODELS = [
  {
    code: "A",
    title: "نموذج A — نموذج الدوبلكس الأرضي",
    area: "250.75 + 177 م²",
    units: "117 - 118 - 119 - 120",
    floors: [
      {
        name: "الدور الأرضي",
        area: "171.95 م²",
        features: [
          "مجلس رجال 4.00 × 5.20",
          "غرفة طعام 4.30 × 4.00",
          "صالة معيشة 4.50 × 8.60",
          "مطبخ 3.50 × 5.10",
          "غرفة نوم ماستر 4.00 × 4.30",
          "غرفة عاملة 1.60 × 2.30",
          "غرفة غسيل 6.00 × 1.61",
          "4 دورات مياه",
        ],
      },
      {
        name: "الدور الأول",
        area: "66.48 م²",
        features: ["غرفة نوم ماستر 4.30 × 4.00", "غرفة نوم ماستر 3.90 × 4.20", "دورتا مياه"],
      },
      { name: "الدور الثاني", area: "12.32 م²", features: ["سطح 32.76 م²"] },
    ],
    image: "/images/brochure-p16.jpg",
  },
  {
    code: "B",
    title: "نموذج B — نموذج الدوبلكس العلوي",
    area: "233 + 69 م²",
    units: "117 - 118 - 119 - 120",
    floors: [
      {
        name: "الدور الأول",
        area: "115.63 م²",
        features: [
          "مجلس رجال 5.20 × 3.80",
          "غرفة طعام 4.00 × 3.50",
          "صالة معيشة 4.00 × 4.80",
          "مطبخ 4.00 × 3.80",
          "دورتا مياه",
        ],
      },
      {
        name: "الدور الثاني",
        area: "117.48 م²",
        features: [
          "غرفة نوم ماستر 4.00 × 5.50",
          "غرفتا نوم",
          "غرفة عاملة 1.70 × 2.85",
          "3 دورات مياه",
          "سطح 2.40 × 6.90",
        ],
      },
    ],
    image: "/images/brochure-p17.jpg",
  },
  {
    code: "C",
    title: "نموذج C — نموذج الدوبلكس الأرضي",
    area: "239 + 134 م²",
    units: "126B - 128 - 130 - 132A",
    floors: [
      {
        name: "الدور الأرضي",
        area: "169.42 م²",
        features: [
          "مجلس رجال 4.00 × 5.40",
          "غرفة طعام 3.50 × 5.60",
          "صالة معيشة 7.20 × 5.60",
          "مطبخ 4.50 × 3.70",
          "غرفة نوم ماستر 4.20 × 3.70",
          "غرفة نوم 3.80 × 3.90",
          "غرفة عاملة 2.20 × 2.90",
          "غرفة غسيل 1.60 × 3.70",
          "4 دورات مياه",
        ],
      },
      {
        name: "الدور الأول",
        area: "58.28 م²",
        features: ["غرفتا نوم ماستر", "دورتا مياه"],
      },
      { name: "الدور الثاني", area: "11.44 م²", features: ["سطح 9.50 × 3.80"] },
    ],
    image: "/images/brochure-p18.jpg",
  },
  {
    code: "D",
    title: "نموذج D — نموذج الدوبلكس العلوي",
    area: "227 + 80 م²",
    units: "126 - 128 - 130 - 132",
    floors: [
      {
        name: "الدور الأول",
        area: "120.56 م²",
        features: [
          "مجلس رجال 5.10 × 3.70",
          "غرفة طعام 4.00 × 3.40",
          "صالة معيشة 5.30 × 6.90",
          "مطبخ 3.95 × 3.50",
          "دورتا مياه",
        ],
      },
      {
        name: "الدور الثاني",
        area: "106.49 م²",
        features: [
          "غرفة نوم ماستر 4.55 × 4.00",
          "غرفتا نوم",
          "غرفة عاملة 4.00 × 2.00",
          "3 دورات مياه",
          "سطح 3.85 × 9.20",
        ],
      },
    ],
    image: "/images/brochure-p19.jpg",
  },
  {
    code: "E",
    title: "نموذج E — نموذج الدوبلكس الأرضي (زاوية)",
    area: "247 + 161 م²",
    units: "126 — وحدة زاوية",
    floors: [
      {
        name: "الدور الأرضي",
        area: "175.21 م²",
        features: [
          "مجلس رجال 4.00 × 5.40",
          "غرفة طعام 5.60 × 3.50",
          "صالة معيشة 5.60 × 7.20",
          "مطبخ 4.50 × 3.70",
          "غرفة نوم ماستر 3.70 × 4.20",
          "غرفة نوم 3.80 × 3.90",
          "غرفة عاملة 2.90 × 2.20",
          "غرفة غسيل 1.60 × 3.70",
          "4 دورات مياه",
        ],
      },
      {
        name: "الدور الأول",
        area: "60.14 م²",
        features: ["غرفتا نوم ماستر", "دورتا مياه"],
      },
      { name: "الدور الثاني", area: "12.10 م²", features: ["سطح 9.50 × 3.80"] },
    ],
    image: "/images/brochure-p20.jpg",
  },
  {
    code: "F",
    title: "نموذج F — نموذج الدوبلكس الأرضي (زاوية)",
    area: "247 + 179 م²",
    units: "132 — وحدة زاوية",
    floors: [
      {
        name: "الدور الأرضي",
        area: "175.21 م²",
        features: [
          "مجلس رجال 4.00 × 5.40",
          "غرفة طعام 5.60 × 3.50",
          "صالة معيشة 5.60 × 7.20",
          "مطبخ 4.50 × 3.70",
          "غرفة نوم ماستر 3.70 × 4.20",
          "غرفة نوم 3.80 × 3.90",
          "غرفة عاملة 2.90 × 2.20",
          "غرفة غسيل 1.60 × 3.70",
          "4 دورات مياه",
        ],
      },
      {
        name: "الدور الأول",
        area: "60.14 م²",
        features: ["غرفتا نوم ماستر", "دورتا مياه"],
      },
      { name: "الدور الثاني", area: "12.10 م²", features: ["سطح 9.50 × 3.80"] },
    ],
    image: "/images/brochure-p21.jpg",
  },
];

export const GALLERY_IMAGES = [
  { src: "/images/exterior-building.jpg", alt: "الواجهة الرئيسية لتاون هاوس الشامخة", span: "col-span-2 lg:col-span-2 row-span-2" },
  { src: "/images/interior-living.jpg", alt: "صالة المعيشة - تشطيب فاخر", span: "" },
  { src: "/images/interior-bedroom.jpg", alt: "غرفة النوم الماستر", span: "" },
  { src: "/images/interior-entrance.jpg", alt: "المدخل الرئيسي والاستقبال", span: "col-span-2 lg:col-span-2" },
  { src: "/images/panorama.jpg", alt: "المخطط العام للمشروع", span: "col-span-2 lg:col-span-4" },
];

// Partner data lives in /components/sections/Partners.jsx for co-located SVG marks.

export const FAQ = [
  {
    q: "أين يقع المشروع بالتحديد؟",
    a: "تاون هاوس الشامخة يقع في مدينة الدمام بحي حديقة الأثير، على بُعد 16 دقيقة من مركز الملك عبدالعزيز الثقافي، 24 دقيقة من مطار الملك فهد، و14 دقيقة من المستشفى السعودي الألماني.",
  },
  {
    q: "ما هي خيارات المساحات المتاحة؟",
    a: "يضم المشروع 6 نماذج (A–F) من تصاميم الدوبلكس، بمساحات إجمالية تتراوح بين 227م² و427م² تقريبًا، تشمل الأدوار الأرضية، العلوية، والأسطح.",
  },
  {
    q: "هل توجد ضمانات على الوحدات؟",
    a: "نعم — ضمان إنشائي لمدة 10 سنوات عبر تأمين التعاونية، إضافة إلى ضمانات تمتد حتى 25 سنة على الكهرباء، السباكة، والعزل، مع خدمات ما بعد البيع كاملة.",
  },
  {
    q: "هل بإمكاني تخصيص التصميم الداخلي؟",
    a: "نعم. خدمة التصميم الداخلي متاحة بأسعار تفضيلية، إضافة إلى توريد وتركيب المطابخ وأنظمة المنزل الذكي بباقات مخصصة.",
  },
  {
    q: "كيف أحجز وحدة أو أحدد زيارة؟",
    a: "املأ نموذج التسجيل أعلاه أو تواصل معنا مباشرة عبر واتساب على +966 50 055 0223 وسيرتب مستشار مُيسر العقاري الزيارة في أقرب وقت.",
  },
];
